import { URL_FOUNDATION } from '../../config/keys';
import axios from 'axios';
import { Cookies } from 'react-cookie';
import { PostTaxBody, Tax, TaxType } from './models';

const cookies = new Cookies();
const token = cookies.get('id_token') || null;
axios.defaults.headers.common.Authorization = `${token}`;

export async function getTaxes(): Promise<Tax[]> {
	return await axios.get<Tax[]>(`${URL_FOUNDATION}/api/tax`).then(res => res.data);
}

export async function getTaxTypes(): Promise<TaxType[]> {
	return await axios.get<TaxType[]>(`${URL_FOUNDATION}/api/tax/types`).then(res => res.data);
}


export async function postTax(body: PostTaxBody): Promise<any> {
	return await axios.post<TaxType[]>(`${URL_FOUNDATION}/api/tax`, body).then(res => res.data);
}

